import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const handleCTA = () => {
    // Track Subscribe event with Facebook Pixel
    if (window.fbq) {
      window.fbq('track', 'Subscribe', {
        source: 'hero_section',
        value: 1,
        currency: 'USD'
      });
    }
    window.open('https://t.me/sinyalbankentry/12328', '_blank');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-black text-white pt-28 md:pt-32 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#ED1C24]/20 via-black to-black"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-7xl mx-auto">
          {/* Text Content */}
          <div className="text-center lg:text-left">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
              Trading Gak Perlu Skill Dewa,{' '}
              <span className="text-[#ED1C24]">Indikator SBE Udah Baca Market</span> Buat Kamu!
            </h1>
            
            <p className="text-lg md:text-xl text-gray-300 mb-12">
              Biarkan Indikator SBE yang kerja, kamu tinggal eksekusi. Cepat, tepat, tanpa ribet.
            </p>
            
            <div className="flex flex-col items-center lg:items-start gap-4">
              <Button 
                onClick={handleCTA}
                className="bg-[#ED1C24] hover:bg-[#c91820] text-white px-8 py-6 text-lg font-semibold rounded-lg transition-all hover:scale-105 shadow-lg shadow-[#ED1C24]/50 w-full sm:w-auto"
              >
                Coba Indikator SBE Sekarang
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </div>
          </div>
          
          {/* Image Content - Desktop & Mobile */}
          <div className="relative">
            <div className="relative">
              <div className="absolute inset-0 bg-[#ED1C24]/10 rounded-full blur-3xl"></div>
              <img 
                src="/arep-hero.png"
                alt="Arep - Founder Sinyal Bank Entry"
                className="relative z-10 w-full max-w-md mx-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#F0F0F0] to-transparent"></div>
    </section>
  );
};

export default Hero;